/**
 * Custom validators
 */
import dateNL from './date-nl'
import hasHouseNumber from './has-house-number'
import houseNumber from './house-number'
import houseNumberAndAddition from './house-number-addition'
import isEighteen from './is-eighteen'
// import emailExists from './email-exists'
import minAge from './min-age'
import checked from './checked'

// export default {
//   dateNL,
//   emailExists,
//   houseNumberAndAddition,
//   houseNumber,
//   hasHouseNumber,
//   isEighteen,
//   minAge,
//   checked,
// }


export default {
  dateNL,
  houseNumberAndAddition,
  houseNumber,
  hasHouseNumber,
  isEighteen,
  minAge,
  checked,
}
